import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-event-pop-up',
  templateUrl: './event-pop-up.component.html',
  styleUrls: ['./event-pop-up.component.scss']
})
export class EventPopUpComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private sanitizer: DomSanitizer,
              public dialogRef: MatDialogRef<EventPopUpComponent>) {
  }

  public options: Object = {
    placeholderText: 'Edit Your Content Here!',
    charCounterCount: false,
    toolbarButtons: ['bold', 'italic', 'underline', 'paragraphFormat', 'html', 'fontSize', 'color', 'formatUL', 'align']
  };

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(false);
  }
}
